import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { API_BASE_URL, buildApiUrl } from './services/api';

const originalFetch = window.fetch.bind(window);

window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  if (typeof input === 'string') {
    if (input.startsWith('/api')) {
      return originalFetch(buildApiUrl(input), init);
    }
    if (input.startsWith(API_BASE_URL)) {
      return originalFetch(input, init);
    }
  }

  return originalFetch(input, init);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
